var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");
lorem.supplemental = require("./supplemental");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/lorem/index.js
 ** module id = 813
 ** module chunks = 0
 **/